import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const links = [
    { to: "/", label: "Accueil" },
    { to: "/approche", label: "Notre approche" },
    { to: "/realisations", label: "Réalisations" },
    { to: "/blog", label: "Blog" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => { setOpen(false); }, [location.pathname]);

    return (
        <header
            className="fixed top-0 left-0 right-0 z-50 bg-brand-bg border-b border-brand-border"
            data-testid="navbar"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-36 md:h-40">
                <Link to="/" className="hover:opacity-80 transition-opacity" data-testid="navbar-logo-link">
                    <Logo variant="horizontal" />
                </Link>
                <nav className="hidden md:flex items-center gap-6 lg:gap-10">
                    {links.map((link) => (
                        <NavLink key={link.to} to={link.to} data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) => `text-base tracking-wide transition-colors ${isActive ? "text-brand-sage" : "text-brand-ink hover:text-brand-sage"}`}
                            end={link.to === "/"}>
                            {link.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="hidden md:block">
                    <Link to="/devis" data-testid="navbar-devis-cta" className="inline-flex items-center px-6 lg:px-8 py-3.5 lg:py-4 bg-brand-sage hover:bg-brand-sageDark text-brand-bg text-xs lg:text-sm uppercase tracking-[0.2em] transition-colors">
                        Demander un devis
                    </Link>
                </div>
                <button className="md:hidden text-brand-ink" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="navbar-mobile-toggle">
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            {open && (
                <div className="md:hidden bg-brand-bg border-t border-brand-border" data-testid="navbar-mobile-panel">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((link) => (
                            <NavLink key={link.to} to={link.to} data-testid={`nav-mobile-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={({ isActive }) => `text-base ${isActive ? "text-brand-sage" : "text-brand-ink"}`}
                                end={link.to === "/"}>
                                {link.label}
                            </NavLink>
                        ))}
                        <Link to="/devis" data-testid="navbar-mobile-devis-cta" className="mt-2 inline-flex items-center justify-center px-6 py-3 bg-brand-sage text-brand-bg text-xs uppercase tracking-[0.2em]">
                            Demander un devis
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
